import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import React, {useEffect} from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import {Switch} from "@mui/material";
function StudyField() {

    const [open,setOpen] = React.useState(0);
    const [value,setValue] = React.useState("");
    const [list,setList] = React.useState([]);
    const [id,setId] = React.useState();
    const [count,setCount] = React.useState(0);
    const [deleteOpen,setDeleteOpen] = React.useState(false);
    const [openStatus,setOpenStatus] = React.useState(false);




    const columns = [
        {
            name: "name",
            label: "Title",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "id",
            data:"status",
            label: "Active",
            options: {
                filter: true,
                sort: true,
                customBodyRender:(v)=>{

                    const obj = list.find(it=>it.id === v);
                    return <Switch checked={obj?.status === true} onChange={()=>{
                        setId(v);
                        setOpenStatus(true);
                    }}/>;
                }
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender:(v)=><BasicMenu onDelete={()=>{
                    setDeleteOpen(true);
                    setId(v);
                }} onEdit={()=>{
                    setOpen(2);
                    const obj = list.find(vx=>vx.id === v);
                    setId(v);
                    setValue(obj.name);
                }}/>
            },
        },
    ];

    const onSuccess = ()=>setCount(v=>v+1);


    return <div className="w-full">
        <DeleteDialog open={openStatus} info={true} setOpen={()=>setOpenStatus(false)} title={'Change Status'} bodyText={'Change status of this Study Field ?'} onSuccess={onSuccess} url={`/api/fields/change/status/${id}`}/>
        <DeleteDialog open={deleteOpen} setOpen={()=>setDeleteOpen(false)} onSuccess={onSuccess} url={`/api/fields/delete/${id}`}/>
        <FormDialog open={open>0} onSuccess={onSuccess} setOpen={setOpen} url={open === 1 ? '/api/fields/create' : `/api/fields/update/${id}`} title={open ===1 ? "Create New Field of Study" : "Edit Field of Study"} fields={[
            {
                name:"name",
                label:"Field name",
                value,
                required:true,
                setValue,
            }
        ]}/>
        <DatatableComponent onAddNew={()=>setOpen(1)} processData={(data)=>{
            setList(data.data);
            return data;
        }} elevation={1} columns={columns} url={`/api/fields/list?count=${count}`} title={"Field of Studies"}/>
    </div>;
}

export default connect(mapStateToProps,mapDispatchToProps)(StudyField);
